import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Grid, Paper, Box } from '@material-ui/core'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import CircularProgress from '@material-ui/core/CircularProgress'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import moment from 'moment'

import { SUBSCRIBER_GENRE_TITLES } from '../../constants/module_info'
import { CATALOG_TITLE, SUBSCRIBER_NETWORK_TYPE_DEFAULT1, SUBSCRIBER_NETWORK_TYPE_DEFAULT2, SUBSCRIBER_NETWORK_TYPE_PRIMARY, TITLE_GENRE, TITLE_GENRE_RANK, TITLE_PREMIERE } from '../../constants/commons'
import DateHelpers from '../../classes/DateHelpers'
import Thumbnail from '../widgets/Thumbnail'

export class SubscriberGenreTitleComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    primaryNetwork: PropTypes.object,
    defaultNetwork1: PropTypes.object,
    defaultNetwork2: PropTypes.object,
    selectedNetwork: PropTypes.string,
    selectedNetworkId: PropTypes.string,
    subscriber: PropTypes.object,
    subscriberGenreTitle: PropTypes.object,
    selectedGenre: PropTypes.string,
    selectedNetworkType: PropTypes.string,
    percentageByGenre: PropTypes.array,
    primaryNetworkData: PropTypes.array,
    defaultNetwork1Data: PropTypes.array,
    defaultNetwork2Data: PropTypes.array
  }

  constructor (props) {
    super(props)

    this.state = {
      page: 0,
      data: []
    }
  }

  componentDidMount () {
    if (this.props.selectedNetworkId && this.props.subscriberGenreTitle && this.props.subscriberGenreTitle.details) {
      this.setGenreTitleData(this.props.subscriberGenreTitle)
    }
  }

  componentDidUpdate (prevProps) {
    if ((prevProps.selectedNetworkId !== this.props.selectedNetworkId && this.props.subscriberGenreTitle && this.props.subscriberGenreTitle.details) || (prevProps.subscriberGenreTitle !== this.props.subscriberGenreTitle && this.props.subscriberGenreTitle.details)) {
      this.setGenreTitleData(this.props.subscriberGenreTitle)
    }
  }

  setGenreTitleData = (genreTitleData) => {
    const tiltesByGenre = genreTitleData.details.catalog_title_genres
    const engagement = tiltesByGenre.filter(e => e.source_topic_id === this.props.selectedNetworkId)
    const data = engagement.length > 0 && engagement[0].data ? engagement[0].data.data : []
    this.setState({ data: data})
  }

  render () {
    const { classes, selectedNetwork, primaryNetwork, defaultNetwork1, defaultNetwork2 } = this. props
    const networkClassName = primaryNetwork && primaryNetwork.network === selectedNetwork ? SUBSCRIBER_NETWORK_TYPE_PRIMARY :
    defaultNetwork1 && defaultNetwork1.network === selectedNetwork ? SUBSCRIBER_NETWORK_TYPE_DEFAULT1 :
    defaultNetwork2 && defaultNetwork2.network === selectedNetwork ? SUBSCRIBER_NETWORK_TYPE_DEFAULT2 : ''
    let rows = this.state.data ? this.state.data : []
    return (
      <Paper className={`infoBox ${classes.paper}`}>
        <Grid container spacing={1} direction="column">
          <Grid item className='cardPadding p-b-0'>
            <span className={`infoBoxTitle ${classes.cardTitle}`}>Titles by Genre</span>
            <OverlayTrigger overlay={<Tooltip id="tooltip">{SUBSCRIBER_GENRE_TITLES}</Tooltip>} placement="right">
              <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
            </OverlayTrigger>
          </Grid>
          <Grid item className={`infoSubGenreTitle ${classes.cardSubTitle}`}>Content catalog details for <span className={networkClassName}>{selectedNetwork}</span></Grid>
        </Grid>
        { (this.props.subscriberGenreTitle && this.props.subscriberGenreTitle.isFetching) &&
          <div className='loadingProgress'>
            <CircularProgress />
          </div>
        }
        { (this.props.subscriberGenreTitle && this.props.subscriberGenreTitle.details) &&
          <TableView
            classes={classes}
            details={rows}
            page={this.state.page}
            selectedNetwork={selectedNetwork}
            selectedGenre={this.props.selectedGenre}
            selectedNetworkType={this.props.selectedNetworkType}
            percentageByGenre={this.props.percentageByGenre}
            primaryNetworkData={this.props.primaryNetworkData}
            defaultNetwork1Data={this.props.defaultNetwork1Data}
            defaultNetwork2Data={this.props.defaultNetwork2Data}
          />
        }
      </Paper>
    )
  }
}

export class TableView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    details: PropTypes.array.isRequired,
    page: PropTypes.number.isRequired,
    selectedNetwork: PropTypes.string,
    selectedGenre: PropTypes.string,
    selectedNetworkType: PropTypes.string,
    percentageByGenre: PropTypes.array,
    primaryNetworkData: PropTypes.array,
    defaultNetwork1Data: PropTypes.array,
    defaultNetwork2Data: PropTypes.array
  }

  constructor (props) {
    super(props)

    this.state = {
      searchText: '',
      order: 'asc',
      orderBy: CATALOG_TITLE,
      orderType: null
    }
    this.searchRef = React.createRef()
  }

  componentDidMount () {
    if (this.state.searchText.length > 0) {
      this.searchRef.current.focus()
    }
  }

  componentDidUpdate (prevProps) {
    if (this.state.searchText.length > 0) {
      this.searchRef.current.focus()
    }
    if (prevProps.selectedGenre !== this.props.selectedGenre) {
      if (this.props.selectedGenre) {
        this.setState({
          order: 'asc',
          orderBy: TITLE_GENRE_RANK
        })
        this.createSortHandler(TITLE_GENRE_RANK)
      } else {
        if (this.state.orderType) {
          this.setState({
            order: 'asc',
            orderBy: CATALOG_TITLE
          })
          this.createSortHandler(CATALOG_TITLE)
        }
      }
    }
  }

  onSearchTextChange = (e) => {
    this.setState({ searchText: e.target.value })
    this.searchRef.current.focus()
  }

  formatDate = (date) => {
    if (date) {
      const premiereDate = moment(date.substring(0, date.indexOf(' ')))
      if (DateHelpers.isYearEndDate(premiereDate)) {
        return premiereDate.format('YYYY')
      }
      return premiereDate.format('MM.DD.YYYY')
    }
    return date
  }

  descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1
    }
    if (b[orderBy] > a[orderBy]) {
      return 1
    }
    return 0
  }

  getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy)
  }

  sortData = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0])
      if (order !== 0) return order
      return a[1] - b[1]
    })
    return stabilizedThis.map((el) => el[0])
  }

  createSortHandler = (property, orderType) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc'
    this.setState({
      order: orderType === undefined ? 'asc' : isAsc ? 'desc' : 'asc',
      orderBy: property,
      orderType: orderType
    })
  }

  render () {
    const { classes } = this.props
    let rows = this.props.details ? this.props.details : []
    rows = rows.length > 0 && rows.sort((a, b) => (a.title < b.title) ? -1 : (a.title > b.title) ? 1 : 0)
    rows = this.state.searchText.length > 0 ? rows.filter(e => e.title.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1) : rows
    rows = this.props.selectedGenre && rows ? rows.filter(r => r.genre.indexOf(this.props.selectedGenre) > -1) : rows
    const StyledTableCell = withStyles(() => ({
      head: {
        background: '#F4F5F6'
      }
    }))(TableCell)

    return (
      <>
        <TableContainer className="commonTable genreTitleTable" id="genreTitleTable">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell className='notesTableSpace' width="5"></StyledTableCell>
                <StyledTableCell>
                  <input type="text" name="title" placeholder="Title" className="titleInput" autoComplete="off" value={this.state.searchText} onChange={this.onSearchTextChange} ref={this.searchRef}/>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === TITLE_GENRE}
                    direction={this.state.orderBy === TITLE_GENRE ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler(TITLE_GENRE, 'self')}
                  >
                    Genre
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === TITLE_PREMIERE}
                    direction={this.state.orderBy === TITLE_PREMIERE ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler(TITLE_PREMIERE, 'self')}
                  >
                    Premiere
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell>
                  <TableSortLabel
                    active={this.state.orderBy === TITLE_GENRE_RANK}
                    direction={this.state.orderBy === TITLE_GENRE_RANK ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler(TITLE_GENRE_RANK, 'self')}
                  >
                    Network Rank
                  </TableSortLabel>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length > 0 && this.sortData(rows, this.getComparator(this.state.order, this.state.orderBy)).map((row, index) => {
                const selectedGenre = this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_PRIMARY ? this.props.primaryNetworkData.filter(g => g.genre === row.genre) : this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT1 ? this.props.defaultNetwork1Data.filter(g => g.genre === row.genre) : this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT2 ? this.props.defaultNetwork2Data.filter(g => g.genre === row.genre) : []
                const bgColor = selectedGenre && selectedGenre.length > 0 ? selectedGenre[0].bg : ''
                return (
                  <TableRow key={`${row.entity_id}_${index}`}>
                    <TableCell className='cellBorder' style={{borderColor: bgColor}}>
                      <Box className="d-flex justify-content-start align-items-center">
                        <Thumbnail
                          entityOverrideImage={row.entity_override_image}
                          thumbnail={row.thumbnail}
                          name={row.title}
                          imageSpanClass={`${classes.whatsNewDefaultImageSpan} whatsNewDefaultImageSpan`}
                          imageClass={`${classes.whatsNewDefaultImage} whatsNewDefaultImage`}
                          noImgTextClass={'homepageNoImgText'}
                          noImgClass={'homepageNoImg'}
                          divId={`subscriber_engagement_${index}`}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>{row.title}</TableCell>
                    <TableCell>{row.genre.replace(',', ', ')}</TableCell>
                    <TableCell>{this.formatDate(row.premiere)}</TableCell>
                    <TableCell>#{row.rank}</TableCell>
                  </TableRow>
                )}
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    )
  }
}

export default withStyles(styles)(SubscriberGenreTitleComponent)
